/* eslint-disable import/prefer-default-export */
import { makeEntityScaffold } from '@classpass/saga-tools';
export var charges = makeEntityScaffold('SAGA.API.CHARGES', function (client, userId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.subscription.getBillingHistory(userId, options).then(function (data) {
    return data.billing_history;
  });
}, {
  defaultKey: 1
});